import React, { FC, useEffect } from 'react'
import Helmet from 'react-helmet'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { fetchSystem } from '../../../../states/containers/setting/systemSlice'
import { RootState } from '../../../../states/containers/store'

import UrlDetailStatus from '../../../components/setting/UrlDetailStatus'

const Index: FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const {
    login,
  } = useSelector((state: RootState) => state)

  useEffect(() => {
    if (!login.accessToken) return
    dispatch(
      fetchSystem(
        () => { /* nothing */ },
      ),
    )
  }, [login.accessToken])

  return (
    <section className="setting_page">
      <Helmet>
        <title>{`Qasee - 設定 - 共通設定 - ${t("setting.web_browser.caption")}`}</title>
      </Helmet>
      <section className="breadcrumb">
        設定
        &nbsp;&gt;&nbsp;
        共通設定
        &nbsp;&gt;&nbsp;
        {t("setting.web_browser.caption")}
        &nbsp;
      </section>
      <section className="page_header">
        <h1>
          {t("setting.web_browser.caption")}
        </h1>
      </section>
      <section className="page_description">
        <p>
          URLとページタイトルを非表示にすることができます。
        </p>
      </section>
      <section className="page_contents">
        <div className="content-block">
          <div className="block-detail">
            <UrlDetailStatus />
          </div>
        </div>
      </section>
    </section>
  )
}

export default Index
